import {
    ReportProblemRounded,
    EditRounded,
    AssignmentRounded,
    UploadFileRounded,
    ManageSearchRounded,
    CheckCircleRounded,
    CancelRounded,
    UndoRounded,
    DoneRounded,
    WarningAmberRounded,
} from '@mui/icons-material';

// color: 'alert' | 'info' | 'success' | 'error' | 'default'
const EVENT_DATA = {
    created: {
        label: 'Contestação aberta',
        description: 'A contestação foi registrada pelo provedor de pagamento.',
        icon: ReportProblemRounded,
        color: 'alert',
    },
    updated: {
        label: 'Contestação atualizada',
        description: 'Informações da contestação foram atualizadas.',
        icon: EditRounded,
        color: 'default',
    },
    evidence_required: {
        label: 'Documentos solicitados',
        description: 'O provedor solicitou o envio de evidências para análise.',
        icon: AssignmentRounded,
        color: 'alert',
    },
    evidence_submitted: {
        label: 'Evidências enviadas',
        description: 'As evidências foram enviadas para análise do provedor.',
        icon: UploadFileRounded,
        color: 'info',
    },
    under_review: {
        label: 'Em análise',
        description: 'A contestação está sendo analisada pelo provedor de pagamento.',
        icon: ManageSearchRounded,
        color: 'info',
    },
    won: {
        label: 'Contestação ganha',
        description: 'A contestação foi resolvida a seu favor.',
        icon: CheckCircleRounded,
        color: 'success',
    },
    lost: {
        label: 'Contestação perdida',
        description: 'A contestação foi resolvida a favor do titular do cartão.',
        icon: CancelRounded,
        color: 'error',
    },
    reversed: {
        label: 'Contestação revertida',
        description: 'A decisão da contestação foi revertida.',
        icon: UndoRounded,
        color: 'default',
    },
    closed: {
        label: 'Contestação encerrada',
        description: 'A contestação foi encerrada.',
        icon: DoneRounded,
        color: 'default',
    },
    warning: {
        label: 'Aviso',
        description: 'Um aviso foi emitido sobre esta contestação.',
        icon: WarningAmberRounded,
        color: 'alert',
    },
};

const EVENT_FALLBACK = {
    label: 'Evento desconhecido',
    description: '',
    icon: ReportProblemRounded,
    color: 'default',
};

export function getChargebackEvent(type) {
    return EVENT_DATA[type] || { ...EVENT_FALLBACK, label: type || EVENT_FALLBACK.label };
}

export const ACTOR_LABELS = {
    provider: 'Processador de pagamento',
    seller: 'Você',
    buyer: 'Comprador',
    system: 'Sistema',
};

export function getActorLabel(actor) {
    return ACTOR_LABELS[actor] || actor || '';
}

export default EVENT_DATA;
